export class MessageModel {
    id: number;
    userId: number;
    textContent: string;

    hasAsset: boolean;
    assetDownloadId: number;
    messageAssetInfo: MessageAsset;

    myReactions: number[];
    messageUserReactions: MessageUserReactionModel[];

    modified: number;

}

export class MessageUserReactionModel {
    userId: number;
    name: string;
    reaction: number;
}

export type MessagePostReaction = {
    messageId: number;
    oldReaction: number;
    newReaction: number;
}

export type MessagePost = {
    conversationId: number;
    textContent: string;
    messageAsset?: MessageAsset;
}

export type MessageAsset = {
    fileName: string;
    fileExtension: string;
    binaryContentBase64?: string;
    binaryContentType?: string;
}